import request from '@/utils/request'

// 登录
export function Login (params) {
  return request({
    url: 'post/team/Login',
    data: params
  })
}

export function TeamAdminLogin (params) {
  return request({
    url: 'post/team/TeamAdminLogin',
    data: params
  })
}

export function SendSms (params) {
  return request({
    url: 'post/team/SendSms',
    data: params
  })
}

export function SendSmsByForgot (params) {
  return request({
    url: 'post/team/SendSmsByForgot',
    data: params
  })
}

export function Register (params) {
  return request({
    url: 'post/team/Register',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js